import slick from "slick-carousel";

$(document).ready(function() {
    const isAutoPlay = $('.main_slider').attr('data-is_active');
    const timeOut = $('.main_slider').attr('data-timeout');

    $('.main_slider').slick({
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: true,
        dots: false,
        autoplay: isAutoPlay == 1 ? true: false,
        autoplaySpeed: isAutoPlay == 1 && timeOut != '' ? timeOut + '000' : false,
    });


    $('.certificates_card').slick({
        infinite: true,
        slidesToShow: 4,
        slidesToScroll: 1,
        arrows: true,
        dots: false,
        responsive: [
            {
                breakpoint: 1440,
                settings: {
                    slidesToShow: 4,
                    slidesToScroll: 1,
                    arrows: true,
                }
            },
            {
                breakpoint: 1200,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1,
                }
            },
            {
                breakpoint: 920,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                }
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                }
            },
        ],
        prevArrow: $('.certificates_arrow_left'),
        nextArrow: $('.certificates_arrow_right'),
    });


    $('.reviews_cards_wrapper').slick({

        infinite: true,
        slidesToShow: 3,
        slidesToScroll: 1,
        arrows: true,
        dots: false,
        centerMode: true,
        responsive: [
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                }
            },
        ],
        prevArrow: $('.reviews_arrow_left'),
        nextArrow: $('.reviews_arrow_right'),
    });



    $('.last_news').slick({

        infinite: true,
        slidesToShow: 3,
        slidesToScroll: 1,
        arrows: true,
        dots: false,
        responsive: [
            {
                breakpoint: 992,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                }
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                }
            },
        ],
        prevArrow: $('.last_news_arrow_left'),
        nextArrow: $('.last_news_arrow_right'),
    });

});



// WEBPACK FOOTER //
// ./resources/js/slick.js